import { createFileRoute } from "@tanstack/react-router";

import { GroupResources } from "@/components/groups/group-resources";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/resources")({
  component: GroupResourcesTab,
});

function GroupResourcesTab() {
  const { groupId, isAdmin, group } = useGroupRouteData(Route.useParams().groupId);

  if (!group?.enableResources) return null;

  return <GroupResources groupId={groupId} isAdmin={isAdmin} />;
}
